import styled from "styled-components";
import { viewSizes } from "../helpers/variables";


interface ContentProps {
    isRegisterModal: boolean
    isVideoModal: boolean
}

export const BackdropWrapper = styled.div`
  opacity: 0.7;
  background-color: #000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 10;
`;

// export const VideoModalWrapper = styled.div`
//   z-index: 100;
//   position: fixed;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
//   background-color: white;
//   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
//   border-radius: 8px;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   overflow: hidden;
//   max-width: 90%;
// `;

export const ModalWrapper = styled.div`
  z-index: 100;
  position: fixed;
  top: 50%;
  left: 50%;
  /* width: 43.2rem; */
  transform: translate(-50%, -50%);
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  max-width: 90%;
  /* font-size: 1.6rem; */
  color: #605e66;

  @media only screen and (max-width: ${viewSizes.mobile}) {
    width: 80%;
    top: 48%;
    transform: translate(-50%, -50%);
    font-size: 2.4rem;
  }
`;
export const Header = styled.div<any>`
  background-color: white;
  color: #282359;
  min-height: 4.6rem;
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  text-align: left;
  font-size: 3.6rem;
  padding: 5rem 5rem 2rem 5rem;

  & > h2 {
    font-size: 3.6rem;
    /* line-height: 1.35; */
  }
`;

function getPadding (props:ContentProps) {
    if (props.isRegisterModal){
        return "5rem"
    }
    if (props.isVideoModal){
        return "0rem"
    }
    return "2.4rem 5rem 5rem 5rem"
}

export const Content = styled.div<any>`
  width: 100%;
  padding: ${getPadding};

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 15rem;
  font-size: 1.6rem;
  
  color: #605e66;

  @media only screen and (max-width: ${viewSizes.mobile}) {
    //padding: 2.4rem 2.4rem 0rem 2.4rem;
  }
`;

export const Content_ = styled.div<any>`
  width: 100%;
  padding: ${getPadding};

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 15rem;
  /* font-size: 1.6rem; */
  font-size: ${(props) => (props.isVideoModal ? "inherit" : "1.6rem")};

  color: #605e66;

  & > .content {
    iframe{
      width: 100%;
    }
    text-align: ${(props) => (props.center ? "center" : "left")};
    font-stretch: normal;
    font-style: normal;
    line-height: 1.35;

    & > article > h1 {
      font-size: 1.6rem;
    }
    // 유의사항 리스트 타입 추가
    .normal {
      li {
        list-style: inside;
      }
    }

    .highlight {
      color: #8466c7;
      margin: 3rem 0;

      & > li {
        list-style: inside;
      }
    }
      
  }

  @media only screen and (max-width: ${viewSizes.mobile}) {
    //padding: 2.4rem 2.4rem 0rem 2.4rem;
  }
`;
export const Footer = styled.div`
  padding: 1rem 0;
  background-color: #f5f5f5;
  width: 100%;
  display: flex;
  justify-content: center;
  align-content: center;

  & > button {
    color: white;
    background-color: #7660d4;
    outline: none;
    border: none;
    cursor: pointer;
    line-height: 1.33;
    /* width: 33%; */
    height: 4.5rem;
    padding: 0.9rem 5.9rem 0.9rem;
    font-size: 1.8rem;

    @media only screen and (max-width: ${viewSizes.mobile}) {
      font-weight: bold;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;
